// extracted by mini-css-extract-plugin
export default {"fullWidth":"kn-z","image":"ln-z","lazyLoadPicture":"mn-z","lazyLoadSpinner":"nn-z","lazyLoadSpin":"on-z","lazyLoadImage":"pn-z","hasStyledAspectRatio":"qn-z"};